var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCrowdenergyS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.3 37.9",
    style: {
      enableBackground: "new 0 0 71.3 37.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M71.3,18.9c0-1.2-0.1-2.3-0.3-3.4H53.1c-0.9,0-1.7,0.4-2.3,1s-0.9,1.5-0.9,2.4s0.4,1.8,0.9,2.4 c0.6,0.6,1.4,1,2.3,1H71C71.2,21.2,71.3,20.1,71.3,18.9 M63.4,13.1h7C69.5,10.2,68,7.7,66,5.6c-3.3-3.4-7.8-5.5-12.9-5.5 c-6,0-11.3,3-14.6,7.6l0,0c-0.8,1-1.6,2.2-2.1,3c-0.9,1.4-2.9,5.3-3.8,7.1c-0.3,0.6-0.5,1-0.5,1l0,0l0,0l0,0l0,0 c-0.1,0.2-0.6,1.3-1.3,2.5c-0.8,1.4-1.9,3.2-3.2,4.9l0,0l0,0c-2.1,3-5.5,4.9-9.4,4.9c-3.2,0-6.2-1.4-8.3-3.6 c-2.1-2.2-3.4-5.2-3.4-8.6s1.3-6.4,3.4-8.6s5-3.6,8.3-3.6c3.8,0,7.2,1.9,9.4,4.9l0,0l0,0c1.3,1.6,2.3,3.4,3,4.8l3.6-6.8 c-0.5-0.7-0.9-1.4-1.4-2l0,0l0,0C29.5,3,24.2,0,18.2,0c-5,0-9.6,2.1-12.9,5.5S0,13.6,0,18.9s2,9.9,5.3,13.4s7.8,5.5,12.9,5.5 c6,0,11.3-3,14.6-7.6l0,0c0.8-1.1,1.6-2.1,2.2-3.2c1.1-1.9,3.2-5.9,4.1-7.8c0.1-0.1,0.6-1.3,1.4-2.7c0.8-1.4,1.9-3.2,3.2-4.9l0,0 l0,0l0,0c2.1-3,5.5-4.9,9.4-4.9c3.2,0,6.2,1.4,8.3,3.6C62.2,11.2,62.8,12.1,63.4,13.1 M40.7,21.5l-3.6,6.8c0.5,0.7,0.9,1.3,1.4,2 l0,0c3.3,4.6,8.6,7.6,14.6,7.6c5,0,9.6-2.1,12.9-5.5c2-2.1,3.5-4.6,4.4-7.5h-7c-0.5,1-1.2,1.9-2,2.7c-2.1,2.2-5,3.6-8.3,3.6 c-3.8,0-7.2-1.9-9.4-4.9l0,0l0,0l0,0C42.5,24.6,41.5,22.8,40.7,21.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrowdenergyS);
export default __webpack_public_path__ + "static/media/logo-crowdenergy-s.01e9be278f15860421f391e90a37da34.svg";
export { ForwardRef as ReactComponent };